<div class="dashboard-container" *ngIf="showData; else noData">
	<div class="" [ngClass]="forDevice ? 'cards-grid-device' : 'cards-grid'">
		<div class="card" *ngFor="let card of cards" [ngClass]="card.class">
			<div class="card-header">
				<span class="icon" [ngClass]="card.iconClass"><i class="icon" [ngClass]="card.icon"></i></span>
				<h3 [innerHTML]="card.title"></h3>
			</div>
			<div class="stat-group">
				<div class="stat-row" *ngFor="let row of card.rows">
					<div class="stat-labels">
						<span>{{ row.label }}</span>
						<span>
							{{ row.value }}{{ row.isHour ? 'h' : '' }} ({{ row.percent }}%)
						</span>
					</div>
					<div class="progress-bar">
						<div class="fill"
							[ngClass]="row.color"
							[style.width.%]="row.percent">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="legend-container" *ngIf="showLegend">
		<h2 class="legend-title">Legend</h2>

		<div class="legend-content">
			<div class="legend-column">
				<h3 class="column-title">Hour Usage:</h3>
				<div class="legend-item">
					<span class="pill bg-blue"></span>
					<span class="label">In-Use</span>
				</div>

				<div class="legend-item">
					<span class="pill bg-yellow"></span>
					<span class="label">Idle</span>
				</div>
				<div class="legend-item">
					<span class="pill bg-gray"></span>
					<span class="label">Off/Charge</span>
				</div>
			</div>

			<div class="legend-column">
				<h3 class="column-title">Amp-Hours:</h3>
				<div class="legend-item">
					<span class="pill bg-blue"></span>
					<span class="label">In-Use Avg Ah</span>
				</div>
				<div class="legend-item">
					<span class="pill bg-deep-orange"></span>
					<span class="label">Max Available Ah</span>
				</div>
			</div>
		</div>
	</div>
	<div class="footer-date" *ngIf="showFooterDate">
		<span [tooltip]="'tooltip.time_source_pc' | translate">Report Generated:</span> {{ today | date:'MM/dd/yyyy' }}
	</div>
</div>

<ng-template #noData>
	<div class="mt-4 pl-3 pr-3">
		<div class="alert alert-info">
		{{ 'g.no_data_to_show' | translate }}
		</div>
	</div>
</ng-template>